import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BsDropdownModule, ModalModule} from 'ngx-bootstrap';
import { LiveDataGraphComponent } from './live-data-graph.component';
import { LiveDataViewComponent } from './live-data-view.component';
import {NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        ModalModule,
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        NgbPopoverModule,
        FormsModule,
    ],
  declarations: [
    LiveDataGraphComponent,
    LiveDataViewComponent
  ],
  exports: [
    LiveDataGraphComponent,
    LiveDataViewComponent
  ]
})
export class LiveDataView {
}
